const initFAQ = () => {
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isExpanded = question.getAttribute('aria-expanded') === 'true';
      
      // Close all other answers first
      faqQuestions.forEach(otherQuestion => {
        if (otherQuestion !== question && otherQuestion.getAttribute('aria-expanded') === 'true') {
          const otherAnswer = otherQuestion.nextElementSibling;
          otherQuestion.setAttribute('aria-expanded', 'false');
          otherAnswer.style.height = otherAnswer.scrollHeight + 'px';
          // Trigger reflow
          otherAnswer.offsetHeight;
          otherAnswer.style.height = '0';
        }
      });

      // Toggle aria-expanded
      question.setAttribute('aria-expanded', !isExpanded);
      
      // Slide animation
      if (!isExpanded) {
        // Opening
        answer.hidden = false;
        const height = answer.scrollHeight;
        answer.style.height = '0';
        // Trigger reflow
        answer.offsetHeight;
        answer.style.height = height + 'px';
      } else {
        // Closing
        answer.style.height = answer.scrollHeight + 'px';
        // Trigger reflow
        answer.offsetHeight;
        answer.style.height = '0';
      }
    });
  });

  // Handle transition end
  document.querySelectorAll('.faq-answer').forEach(answer => {
    answer.addEventListener('transitionend', () => {
      if (answer.style.height === '0px') {
        answer.hidden = true;
      } else {
        answer.style.height = 'auto';
      }
    });
  });
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQ);
} else {
  initFAQ();
}